export default __webpack_public_path__ + "static/media/thunder.f2c909fd.svg";